var _path, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVisitors(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 64,
    viewBox: "0 0 80 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 20.75C0 37.3185 37.4315 63.75 54 63.75C70.5685 63.75 80 46.8185 80 30.25C80 13.6815 66.5685 0.25 50 0.25C33.4315 0.25 0 4.18146 0 20.75Z",
    fill: "#FFE5E4"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_129_6537)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M47 30.7794C49.6406 30.7794 51.7812 28.6462 51.7812 26.0147C51.7812 23.3832 49.6406 21.25 47 21.25C44.3594 21.25 42.2188 23.3832 42.2188 26.0147C42.2188 28.6462 44.3594 30.7794 47 30.7794Z",
    fill: "#FE5F55"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.0938 32.8971C59.1476 32.8971 60.8125 31.2379 60.8125 29.1912C60.8125 27.1445 59.1476 25.4854 57.0938 25.4854C55.0399 25.4854 53.375 27.1445 53.375 29.1912C53.375 31.2379 55.0399 32.8971 57.0938 32.8971Z",
    fill: "#FE5F55"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.3641 32.6609C59.5081 33.4629 58.3573 33.956 57.0922 33.956C56.7662 33.956 56.4481 33.9229 56.1406 33.8607C57.0823 35.4403 57.6235 37.2833 57.6235 39.2501H63.4672C63.7607 39.2501 63.9985 39.0132 63.9985 38.7207C63.9985 36.1047 62.5262 33.8249 60.3641 32.6609Z",
    fill: "#FE5F55"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.9062 32.8971C38.9601 32.8971 40.625 31.2379 40.625 29.1912C40.625 27.1445 38.9601 25.4854 36.9062 25.4854C34.8524 25.4854 33.1875 27.1445 33.1875 29.1912C33.1875 31.2379 34.8524 32.8971 36.9062 32.8971Z",
    fill: "#FE5F55"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.9062 33.956C35.6412 33.956 34.4904 33.4629 33.6344 32.6609C31.4722 33.8249 30 36.1047 30 38.7207C30 39.0132 30.2377 39.2501 30.5312 39.2501H36.375C36.375 37.2833 36.9169 35.4403 37.8579 33.8607C37.5504 33.9229 37.2316 33.956 36.9062 33.956Z",
    fill: "#FE5F55"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.7446 30.4817C49.73 31.3281 48.4237 31.8383 47 31.8383C45.5763 31.8383 44.27 31.3281 43.2554 30.4817C39.8381 31.9362 37.4375 35.3185 37.4375 39.2501H56.5625C56.5625 35.3192 54.1613 31.9369 50.7446 30.4817Z",
    fill: "#FE5F55"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_129_6537"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 34,
    height: 18,
    fill: "white",
    transform: "translate(30 21.25)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVisitors);
export default __webpack_public_path__ + "static/media/visitors.5caf97753ecb641effb4d0e7cff404c4.svg";
export { ForwardRef as ReactComponent };